import React, { forwardRef, InputHTMLAttributes, useState, useEffect } from 'react';
import InputBase from '../InputBase';
import { IInputProps } from '../InputBase/InputBase';
import { createProgressiveMask } from '../../utils/utils';

enum Banking {
    routing = 'XXXXXXXXX',
    account = 'XXXXXXXXXXXXXXXXX',
}

interface IInputMaskingProps extends IInputProps {
    className?: string;
    value: string;
    setValue: (ssn: string) => void;
    allowedChars?: RegExp | string,
    maskingOptions?: 'routing' | 'account' | '';
    mask?: string;
}

const InputMasking = forwardRef(
    ({
        className = '',
        value = '',
        setValue,
        mask = '',
        allowedChars = '0',
        maskingOptions = '',
        onBlur,
        onFocus,
        ...rest
    }: IInputMaskingProps & InputHTMLAttributes<any>, ref:any) => {
        const customMask = mask || Banking[maskingOptions];
        const customAllowedChars = !mask && maskingOptions === 'account' ? /[0-9A-Za-z]/g : allowedChars;

        const [isVisible, setIsVisible] = useState(false);
        const [maskObjects, setMaskObjects]=useState(createProgressiveMask(customMask, customAllowedChars, isVisible ? undefined : '*'));
        
        useEffect(() => {
            setMaskObjects(createProgressiveMask(customMask, customAllowedChars, isVisible ? undefined : '*'));
        }, [isVisible])
        
        return (
            <InputBase 
                {...rest}
                ref={ref}
                className={`InputMasking ${className || ''}`}
                value={value}
                setValue={setValue}
                mask={maskObjects}
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                onBlur={(e: React.FocusEvent<HTMLInputElement>)=>{
                    onBlur && onBlur(e);
                }}
                onKeyPress={(e:React.KeyboardEvent<HTMLInputElement>) => {
                    if (typeof customAllowedChars === 'object' && !customAllowedChars.test(e.key)) {
                        e.preventDefault();
                    }
                }}
                onFocus={(e: React.FocusEvent<HTMLInputElement>)=> {
                    onFocus && onFocus(e);
                }}
            />
        )
    });

InputMasking.displayName = 'InputMasking';

export default InputMasking;